import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  surveyExecutionHeaderBlockSx,
  surveyExecutionHeaderSubtitleSx,
  surveyExecutionHeaderTitleSx,
} from '../../styles/surveyExecutionStyles'

interface SurveyExecutionHeaderProps {
  readonly name: string
  readonly description?: string | null
}

/** Figma 5074-13253 — instrument name + optional description in navy band. */
export function SurveyExecutionHeader({ name, description }: SurveyExecutionHeaderProps) {
  const subtitle = description?.trim() ?? ''

  return (
    <Box sx={surveyExecutionHeaderBlockSx} data-testid="survey-execution-header">
      <Typography component="h1" sx={surveyExecutionHeaderTitleSx}>
        {name}
      </Typography>
      {subtitle ? (
        <Typography component="p" sx={surveyExecutionHeaderSubtitleSx}>
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  )
}
